export const SUBJECT_GET_MULTIPLE =  "SUBJECT_GET_MULTIPLE"
export const SUBJECT_GET_DROPDOWNS =  "SUBJECT_GET_DROPDOWNS"
export const SUBJECT_GET_ONE =  "SUBJECT_GET_ONE"
export const SUBJECT_REGISTER_SUCCESS =  "SUBJECT_REGISTER_SUCCESS"
export const SUBJECT_REGISTER_FAIL =  "SUBJECT_REGISTER_FAIL"
export const SUBJECT_LOADING =  "SUBJECT_LOADING"
export const SUBJECT_LOADING_ERROR =  "SUBJECT_LOADING_ERROR"
export const SUBJECT_ACTIVATE_FAIL =  "SUBJECT_ACTIVATE_FAIL"
export const SUBJECT_ACTIVATE_SUCCESS =  "SUBJECT_ACTIVATE_SUCCESS"
export const SUBJECT_UPDATE_SUCCESS =  "SUBJECT_UPDATE_SUCCESS"
export const SUBJECT_UPDATE_FAIL =  "SUBJECT_UPDATE_FAIL"
export const SUBJECT_DELETE_SUCCESS =  "SUBJECT_DELETE_SUCCESS"
export const SUBJECT_DELETE_FAIL =  "SUBJECT_DELETE_FAIL"
export const SUBJECT_EDIT =  "SUBJECT_EDIT"